import React from 'react'

import { Grid } from 'semantic-ui-react'

import PageHeaderRow from 'Components/PageHeaderRow'

import * as styles from './styles'

const StatusModule = () => (
  <Grid>
    <Grid.Row columns={1}>
      <Grid.Column width={16}>
        <div style={styles.header}>
          <PageHeaderRow title="Status" />
        </div>
        <iframe
          src="http://prtg.jankath.local/public/mapshow.htm?id=3264&mapid=81969B49-5D5A-43DC-8905-C4AE59802EF4"
          style={styles.iframe}
          title="Status"
        />
      </Grid.Column>
    </Grid.Row>
  </Grid>
)

export default StatusModule
